export const locations = {
  seo: {
    title: '門市據點 | LensBank 專業器材租賃',
    description: '8 個服務據點遍布台北、台中、台南，提供便利的器材租借服務。查看門市地址、營業時間、聯絡方式與交通資訊。',
    keywords: '門市據點,器材租借地點,台北門市,台中門市,台南門市,倉庫'
  },
  hero: {
    title: '門市據點',
    subtitle: '{{count}} 個服務據點，提供便利的器材租借服務'
  },
  types: {
    all: '全部',
    store: '門市',
    warehouse: '倉庫'
  },
  card: {
    store: '門市',
    warehouse: '倉庫',
    hours: '營業時間',
    phone: '電話',
    address: '地址',
    viewDetails: '查看詳情',
    getDirections: '取得路線'
  },
  detail: {
    overview: '據點資訊',
    hours: '營業時間',
    contact: '聯絡方式',
    phone: '電話',
    email: '電子郵件',
    address: '地址',
    transportation: '交通方式',
    services: '提供服務',
    equipmentRental: '器材租賃',
    consultation: '專業諮詢',
    technicalSupport: '技術支援',
    pickup: '器材取件',
    return: '器材歸還',
    map: '地圖',
    nearbyStores: '附近據點'
  },
  hours: {
    monday: '週一',
    tuesday: '週二',
    wednesday: '週三',
    thursday: '週四',
    friday: '週五',
    saturday: '週六',
    sunday: '週日',
    closed: '公休'
  }
};